import React from 'react';
import Script from "next/script";

const Clarity = ({ ga_id }) => (
  <Script id="clarity-script" strategy="afterInteractive">
    {`
        (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "${process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID}");
    // Send consent signal
  clarity('consent', 'granted');  // or 'denied' based on user's choice
    `}
  </Script>
);
export default Clarity;
